import type { EntityOption } from '@/components/EntitySelect';
import { createCategory, getCategory, getService, listCategories, listServices } from './api';

/** Category picker (ServiceCategory list — no server search, so query is ignored). */
export async function searchCategories(_query: string): Promise<EntityOption[]> {
  const page = await listCategories();
  return page.results.map((c) => ({ value: String(c.id), label: c.name }));
}

export async function resolveCategoryLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const category = await getCategory(Number(value));
  return category.name;
}

/** Create a new ServiceCategory inline from the picker. */
export async function createCategoryName(name: string): Promise<EntityOption> {
  const category = await createCategory(name.trim());
  return { value: String(category.id), label: category.name };
}

/** Service picker (rate card) — used by Proposal/Invoice line forms (`?search=`). */
export async function searchServices(query: string): Promise<EntityOption[]> {
  const page = await listServices({ search: query || undefined, is_active: true });
  return page.results.map((s) => ({ value: String(s.id), label: s.name }));
}

export async function resolveServiceLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const service = await getService(Number(value));
  return service.name;
}
